import PropTypes from 'prop-types';

import Price from 'shopper/components/Price/V2';

import { toFormattedOfferOldPrice } from 'lib/offer';
import { toFormattedOfferPrice } from 'lib/offerPage';

const OfferPrice = ({ offerOldPrice = null, offerPrice, offerPriceType }) => (
  <Price
    className="flex-row-reverse items-center gap-x-1"
    primaryInfo={toFormattedOfferPrice(offerPrice, offerPriceType)}
    secondaryInfo={toFormattedOfferOldPrice(offerOldPrice, offerPriceType)}
    size="size1"
  />
);

OfferPrice.propTypes = {
  offerOldPrice: PropTypes.number,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
};

export default OfferPrice;
